import React, { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../_App/Redux/hooks";
import {
  findCamions,
  findVehicules,
  findVehiculesAffectations,
  findVehiculesAffectationsHistory,
  findZones,
} from "../_App/Redux/Slices/vehicules/vehiculesSlice";
import VehiculesList from "../Components/Vehicules/ListVehicules";
import VehiculeForm from "../Components/Vehicules/VehiculeForm";
import {
  currentSousSociete,
  findUsers,
  OnlineUser,
} from "../_App/Redux/Slices/auth/authSlice";
import { findFiles } from "../_App/Redux/Slices/files/filesSlice";

const Vehicules = () => {
  const dispatch = useAppDispatch();
  const [showModal, setShowModal] = useState(false);
  const [selectedVehicule, setSelectedVehicule] = useState(undefined);
  const [load, setLoad] = useState(false);
  const currentSousSte = useAppSelector(currentSousSociete);
  const [searchTerm, setSearchTerm] = useState(""); // Add state for search term

  useEffect(() => {
    if (currentSousSte) dispatch(findVehicules(currentSousSte));
    dispatch(findCamions(null));
    dispatch(findUsers(null));
    dispatch(findVehiculesAffectations(null));
    dispatch(findZones(null));
    dispatch(findFiles(null))
  }, [dispatch, load, currentSousSte]);
  return (
    <div>
      <nav className="navbar search-bar">
        <a href="#" className="sidebar-toggler">
          <i data-feather="menu" />
        </a>
        <div className="navbar-content">
          <form className="search-form">
            <div className="input-group">
              <div className="input-group-prepend">
                <div className="input-group-text">
                  <i data-feather="search" />
                </div>
              </div>
              <input
                type="text"
                className="form-control"
                id="navbarForm"
                placeholder="Chercher ..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)} // Update search term state
              />
            </div>
          </form>
        </div>
      </nav>
      <nav className="page-breadcrumb">
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <a href="#">Vehicules</a>
          </li>
        </ol>
      </nav>
      <div className="row content-card">
        <div className="col-12">
          <div className="card">
            <div className="card-header">
              <i className="mdi mdi-tune-vertical text-primary " /> Liste des
              Vehicules{" "}
              <button
                className="btn btn-primary float-right"
                onClick={() => setShowModal(true)}
              >
                +
              </button>
            </div>
            <VehiculesList
              searchTerm={searchTerm} // Pass search term as a prop
              selectedVehicule={selectedVehicule}
              setSelectedVehicule={setSelectedVehicule}
              setShowModal={setShowModal}
              load={load}
              setLoad={setLoad}
            />
            <VehiculeForm
              showModal={showModal}
              setShowModal={setShowModal}
              selectedVehicule={selectedVehicule}
              setSelectedVehicule={setSelectedVehicule}
              load={load}
              setLoad={setLoad}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Vehicules;
